import React from 'react';
import moment from 'moment';
import { useSelector } from 'react-redux';

export const ItemRow = ({ item }) => {
    const filials = useSelector(state => state.handbook.filials);

    const renderPoint = () => {
        const entityPoint = filials.find((p) => +p.id === +item.point);
        if (!entityPoint) return '-';
        return `${entityPoint.city.name}, ${entityPoint.street}, ${entityPoint.house}`;
    };

    const renderAdress = () => {
        const { area, street, house, entrance, room } = item;

        let text = '';
        if (area && area !== '-') text += `район ${area}, `;
        if (street && street !== '-') text += `ул. ${street}, `;
        if (house && house !== '-') text += `д. ${house}, `;
        if (entrance && entrance !== '-') text += `под. ${entrance}, `;
        if (room && room !== '-') text += `кв. ${room}`;
        return text !== '' ? text : '-';
    }

    const renderErrorGood = (error) => {
        const renderValue = () => {
            switch (error.field) {
                case 'errorPrice': return 'Невалидное значение цены товара.';
                case 'originalGood': return `Передан и не найден товар с id: ${error.goodId}, наименование: ${error.goodLabel}.`;
                case 'name': return `Передан товар с некоректным наименованием - id: ${error.goodId}, наименование: ${error.goodLabel}. Валидное наименование: ${error.validValue}.`;
                case 'price': return `Передан товар с некоректной ценой - id: ${error.goodId}, наименование: ${error.goodLabel}, цена: ${error.value}. Валидная цена: ${error.validValue}.`;
                case 'id': return `Передан товар без id, index: ${error.index}.`;
                case 'wokData': return `Передан товар с неккоректной wokData, index: ${error.index}.`;
                case 'wokData.id': return `Передан ВОК без id, index: ${error.index}.`;
                case 'wokData.main': return `Передан ВОК с неккоректной основой, index: ${error.index}. ${error.wokName}`;
                case 'wokData.main.id': return `Передан ВОК без id основы, index: ${error.index}. ${error.wokName}`;
                case 'wokData.meat': return `Передан ВОК с неккоректным мясом, index: ${error.index}. ${error.wokName}`;
                case 'wokData.meat.data': return `Передан ВОК без data мяса, index: ${error.index}. ${error.wokName}`;
                case 'wokData.meat.data.id': return `Передан ВОК без id мяса, index: ${error.index}. ${error.wokName}`;
                case 'wokData.topping': return `Передан ВОК с неккоректным топпингом, index: ${error.index}. ${error.wokName}`;
                case 'wokData.topping.data': return `Передан ВОК без data топпинга, index: ${error.index}. ${error.wokName}`;
                case 'wokData.topping.data.id': return `Передан ВОК без id топпинга , index: ${error.index}. ${error.wokName}`;
                case 'wokData.souce.id': return `Передан ВОК без id соуса , index: ${error.index}. ${error.wokName}`;
                default: return;
            }
        }

        return (
            <div>
                {renderValue()}
            </div>
        );
    }

    const renderErrorPromotion = (error, promo) => {
        const renderValue = () => {
            switch (error.field) {
                case 'minPrice': return `${promo} - сумма заказ меньше минимальной суммы. Сумма заказ: ${error.value}, мин. сумма акции/промокода: ${error.validValue}.`;
                case 'date': {
                    const { start, end } = error.validValue;
                    return `Передана не действующая ${promo}. Дата заказа: ${error.value}, период проведения акции/промокода: ${start} - ${end}.`
                }
                case 'startDate': return `Передана не действующая ${promo}. Дата заказа: ${error.value}, дата начала акции/промокода: ${error.validValue}.`;
                case 'endDate': return `Передана не действующая ${promo}. Дата заказа: ${error.value}, дата окончания акции/промокода: ${error.validValue}.`;
                case 'time': {
                    const { start, end } = error.validValue;
                    return `Передана не действующая ${promo}. Время заказа: ${error.value}, время проведения акции: ${start} - ${end}.`
                }
                case 'startTime': return `Передана не действующая ${promo}. Время заказа: ${error.value}, время начала акции: ${error.validValue}.`;
                case 'endTime': return `Передана не действующая ${promo}. Время заказа: ${error.value}, время окончания акции: ${error.validValue}.`;
                case 'city': {
                    const text = typeof error.validValue === 'number' || typeof error.validValue === 'string' ? error.validValue : (error.validValue || []).join(', ')
                    return `Передана не действующая в городе акция. ID города в заказе: ${error.value}, id доступных городов: ${text}.`;
                }
                case 'deliveryMethod': return `Передана ${promo} не действующая на данный тип доставки. Переданный тип доставки: ${error.value}, валидный тип доставки: ${error.validValue}.`;
                case 'bonusCount': return `Переданы бонусные баллы: ${error.value}, данная ${promo} не суммируется с бонусными баллами.`;
                case 'undefinedSaleData': return `Передана не существующая ${promo}`;
                case 'type': return `${promo} - передана неверный тип. Передан тип: ${error.value}, валидный тип: ${error.validValue}`;
                case 'value': return `${promo} - передана неверное значение скидки. Передано: ${error.value}, валидное: ${error.validValue}. ${error.goodId ? ` Товар - id: ${error.goodId}, наименование: ${error.goodLabel || '-'}.` : ''}${error.categoryId ? ` Категория - id: ${error.categoryId}, наименование: ${error.categoryLabel || '-'}.` : ''}`;
                case 'persent': return `${promo} - передана неверное значение тип скидки. Передано: ${!!error.value ? '%' : 'сумма'}, валидное: ${!!error.validValue ? '%' : 'сумма'}. ${error.goodId ? ` Товар - id: ${error.goodId}, наименование: ${error.goodLabel || '-'}.` : ''}${error.categoryId ? ` Категория - id: ${error.categoryId}, наименование: ${error.categoryLabel || '-'}.` : ''}`;
                case 'sale': return `${promo} - передана неверное значение скидки. Передано: ${error.value}, валидное: ${error.validValue}. ${error.goodId ? ` Товар - id: ${error.goodId}, наименование: ${error.goodLabel || '-'}.` : ''}${error.categoryId ? ` Категория - id: ${error.categoryId}, наименование: ${error.categoryLabel || '-'}.` : ''}`;
                case 'undefinedSaleGood': return `Не найден промотовар - id: ${error.goodId}, наименование: ${error.goodLabel}`;
                case 'undefinedSaleCategory': return `Не найдена промокатегория - id: ${error.categoryId}, наименование: ${error.categoryLabel}`;
                case 'article': return `Передан не совпадающие атрикл. Передан: ${error.value}, валидный: ${error.validValue}. Товар - id: ${error.goodId}, наименование: ${error.goodLabel};`
                case 'disabled': return `${promo} - отключен(а). Переданный id ${promo}: ${error.value}.`
                case 'incorrect': return `${promo} - не существует. Код: ${error.value}`;
                default: return;
            }
        }

        return (
            <div>
                {renderValue()}
            </div>
        );
    }

    const renderErrorPromoGood = (error) => {
        const renderValue = () => {
            switch (error.field) {
                case 'undefiendPromoGood': return 'Переданы промотовары, данные о которых отсутсвуют в скидке.';
                case 'incorrectPromoGood': return `Передан неккоректный промотовар id: ${error.goodId}, наименование: ${error.goodLabel}${error.count > 0 ? `, кол-во: ${error.count}` : ''}.`;
                case 'price': return `Передан промотовар с некоректной ценой id: ${error.goodId}, наименование: ${error.goodLabel}, переданная цена: ${error.value}, валидная цена: ${error.validValue}.`;
                default: return;
            }
        }

        return (
            <div>
                {renderValue()}
            </div>
        );
    }

    const renderErrorCashback = (error) => {
        const renderValue = () => {
            switch (error.field) {
                case 'user': return 'Переданы данные о начислении ББ без авторизации.';
                case 'level1': 
                case 'level2': 
                case 'level3': 
                return `Переданы неккоректные данные о начислении ББ ${error.field} - передано: ${error.value}, валидное значение: ${error.validValue}.`;
                default: return;
            }
        }

        return (
            <div>
                {renderValue()}
            </div>
        );
    }

    const renderErrorCity = (error) => {
        const renderValue = () => {
            switch (error.field) {
                case 'city': return 'Не переданы данные о городе.';
                default: return;
            }
        }

        return (
            <div>
                {renderValue()}
            </div>
        );
    }

    const renderErrorResultPrice = (error) => {
        return (
            <div>
                {`Передано невалидное значение для поля ${error.field}, передано: ${error.value}, валидное значение: ${error.validValue}.`}
            </div>
        );
    }

    const renderErrorZone = (error) => {
        const renderValue = () => {
            switch (error.field) {
                case 'undefined': return 'Передана не существующая зона доставки.';
                default: return;
            }
        }

        return (
            <div>
                {renderValue()}
            </div>
        );
    }

    const renderErrorSaleFirstOrder = (error) => {
        const renderValue = () => {
            switch (error.field) {
                case 'undefinedUser': return 'Применена скидка на первый заказ без авторизации.';
                case 'orders': return 'Применена скидка на первый заказ, кол-во заказов клиента не равно 0.';
                case 'disabled': return 'Применена скидка на первый заказ, скидка на первый заказ отключена.';
                case 'value': return `Передано неверное значение скидки на первый заказ - передано: ${error.value}, валидное значение: ${error.validValue}.`;
                case 'persent': return `Передано неверное значение типа скидки на первый заказ - передано: ${!!error.value ? '%' : 'сумма'}, валидное значение: ${!!error.validValue ? '%' : 'сумма'}.`;
                default: return;
            }
        }

        return (
            <div>
                {renderValue()}
            </div>
        );
    }

    const renderErrorBonusCount = (error) => {
        const renderValue = () => {
            switch (error.field) {
                case 'undefinedUser': return 'Списаны ББ без авторизации.';
                case 'limitBalanceUser': return `Превышено кол-во списываемых ББ. Списано в заказ: ${error.value}, баланc ББ пользователя: ${error.validValue}.`;
                case 'limitBonusCount': return `Превышено кол-во списываемых ББ. Списано в заказ: ${error.value}, максимальная сумма для данного заказа: ${error.validValue}.`;
                default: return;
            }
        }

        return (
            <div>
                {renderValue()}
            </div>
        );
    }

    const renderErrors = () => {
        return (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px'}}>
                {
                    (item.errors || []).map((error) => {
                        switch (error.type) {
                            case ('good'): return renderErrorGood(error);
                            case ('promotion'):
                            case ('promocode'): 
                            return renderErrorPromotion(error, error.type === 'promocode' ? 'Промокод' : 'Акция');
                            case ('promoGood'): return renderErrorPromoGood(error);
                            case ('cashback'): return renderErrorCashback(error);
                            case ('city'): return renderErrorCity(error);
                            case ('goodsPrice'):
                            case ('deliveryPrice'):
                            case ('salePrice'):
                            case ('totalPrice'):
                            return renderErrorResultPrice(error);
                            case ('zone'): return renderErrorZone();
                            case ('saleFirstOrder'): return renderErrorSaleFirstOrder(error);
                            case ('bonusCount'): return renderErrorBonusCount(error);
                            default: return null;
                        }
                    })
                }
            </div>
        )
    }

    const renderBodyMobile = () => {
        return(
            <div className='mobile_div_flex column padding10px'>
                <div className='mobile_div_flex'>
                    <div style={{ width: '50%' }}>
                        Дата:
                    </div>
                    <div style={{ width: '50%', color: '#000' }}>
                        {moment(item.created_at).format('DD.MM.YYYY HH:mm')}
                    </div>
                </div>
                <div className='mobile_div_flex'>
                    <div style={{ width: '50%' }}>
                        Телефон:
                    </div>
                    <div style={{ width: '50%', color: '#000' }}>
                        {item.phone || '-'}
                    </div>
                </div>
                <div className='mobile_div_flex'>
                    <div style={{ width: '50%' }}>
                        Источник:
                    </div>
                    <div style={{ width: '50%', color: '#000' }}>
                        {item.source || '-'}
                    </div>
                </div>
                <div className='mobile_div_flex'>
                    <div style={{ width: '50%' }}>
                        Тип доставки:
                    </div>
                    <div style={{ width: '50%', color: '#000' }}>
                        {item.deliveryMethod === 'delivery' ? 'Доставка' : 'Вынос'}
                    </div>
                </div>
                <div className='mobile_div_flex'>
                    <div style={{ width: '50%' }}>
                        Филиал:
                    </div>
                    <div style={{ width: '50%', color: '#000' }}>
                        {renderPoint()}
                    </div>
                </div>
                <div className='mobile_div_flex'>
                    <div style={{ width: '50%' }}>
                        Адрес:
                    </div>
                    <div style={{ width: '50%', color: '#000' }}>
                        {renderAdress()}
                    </div>
                </div>
                <div className='mobile_div_flex column'>
                    <div style={{ width: '100%' }}>
                        Причины блокировки:
                    </div>
                    <div style={{ width: '100%', color: '#000' }}>
                        {renderErrors()}
                    </div>
                </div>
            </div>
        );
    }

    if(window.innerWidth < 550)
        return(
            <tr key={`${item.id}_ip`} className="kt-datatable__row">
                {renderBodyMobile()}
            </tr>
        );

    return (
        <tr key={`${item.id}_ip`} className="kt-datatable__row">
            <td className="kt-datatable__cell" style={{ width: '150px' }}><span>{moment(item.created_at).format('DD.MM.YYYY HH:mm')}</span></td>
            <td className="kt-datatable__cell" style={{ width: '150px' }}><span>{item.phone || '-'}</span></td>
            <td className="kt-datatable__cell" style={{ width: '70px' }}><span>{item.source || '-'}</span></td>
            <td className="kt-datatable__cell" style={{ width: '70px' }}><span>{item.deliveryMethod === 'delivery' ? 'Доставка' : 'Вынос'}</span></td>
            <td className="kt-datatable__cell" style={{ width: '150px' }}><span>{renderPoint()}</span></td>
            <td className="kt-datatable__cell" style={{ width: '250px' }}><span>{renderAdress()}</span></td>
            <td className="kt-datatable__cell" style={{ width: 'auto' }}>{renderErrors()}</td>
        </tr>
    );
}
